
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Divider, VStack } from '@chakra-ui/react';
import { GetStaticProps } from 'next';
import I18nProvider from 'next-translate/I18nProvider';
import useTranslation from 'next-translate/useTranslation';
import HeadModule from '../../components/Modules/HeadModule';
import ServiceHeader from '../../components/Modules/ServiceHeader';
import ServiceList from '../../components/Modules/ServiceList';
import ServiceGroupButtons from '../../components/ServiceGroup/ServiceGroupButtons';
import SkillProductDescriptionPlayground from '../../components/Skill/ProductDescription/SkillProductDescriptionPlayground';
import { SKILL_PRODUCT_DESCRIPTION_EXAMPLES } from '../../constants/skillExamples';
import { COPYWRITING_FOR_PRODUCTS_SKILLS, getFourRandomSkills, SKILL_PRODUCT_DESCRIPTION, } from '../../constants/skills';
import examplesDE from '../../locales/de/examples.json';
import examplesEN from '../../locales/en/examples.json';
import examplesFR from '../../locales/fr/examples.json';
import { SkillProvider } from '../../utils/SkillContext';
const SkillProductDescription = ({ otherServices }: any) => {
    const skillsGroup = COPYWRITING_FOR_PRODUCTS_SKILLS;
    const { t, lang } = useTranslation();
    return (<I18nProvider lang={lang} namespaces={{ examplesFR, examplesEN, examplesDE }}>
      <>
        <HeadModule title='meta_title_skill_product_description' description='meta_description_skill_product_description'/>
        <VStack w='full' spacing={20}>
          <VStack w='full' spacing={10}>
            <ServiceHeader serviceGroup={skillsGroup}/>
            <ServiceGroupButtons serviceGroup={skillsGroup}/>
            <SkillProvider skill={SKILL_PRODUCT_DESCRIPTION} skillGroup={skillsGroup} skillExamples={SKILL_PRODUCT_DESCRIPTION_EXAMPLES}>
              <SkillProductDescriptionPlayground />
            </SkillProvider>
          </VStack>
          <Divider variant='separator2' w={64}/>
          <ServiceList title={t('common:our_other_products')} serviceGroups={JSON.parse(otherServices)}/>
        </VStack>
      </>
    </I18nProvider>);
};
const getStaticProps: GetStaticProps = async () => {
    const otherServices = getFourRandomSkills();
    return {
        props: {
            otherServices: JSON.stringify(otherServices),
        },
        revalidate: 900,
    };
};
// noinspection JSUnusedGlobalSymbols
export default SkillProductDescription;

    async function __Next_Translate__getStaticProps__196fbffbb5a__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/copywriting/product-description',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196fbffbb5a__ as getStaticProps }
  